import {
    BrandType,
    JobLanguagesType,
    LanguagesType,
    OutputLanguagesType,
} from 'components/DefaultSettings/types';
import { collection, doc, onSnapshot, orderBy, query } from 'firebase/firestore';
import { Dispatch, SetStateAction } from 'react';
import { AppDispatch } from 'store';
import { setOutputLanguages, setTargetCountries } from 'store/global/globalSlice';
import { TargetCountryType } from 'store/global/types';
import {
    BRANDS,
    LANGUAGES,
    OUTPUT_LANGUAGES,
    POST_DEFAULT_LANGUAGES,
    TARGET_COUNTRIES,
} from 'utils/config/constants/controllerNames';
import { db } from 'utils/config/firebase';
import { errorLogger } from 'utils/config/firebase/logs';

export const getOutputLanguages = (dispatch: AppDispatch) => {
    try {
        const collectionRef = collection(db, OUTPUT_LANGUAGES);
        const q = query(collectionRef, orderBy('name', 'asc'));
        onSnapshot(q, (snapshot) => {
            if (snapshot.docs[0]) {
                const filteredData: OutputLanguagesType[] = snapshot.docs.map((doc) => ({
                    framework_id: doc.data().framework_id,
                    id: doc.data().id,
                    name: doc.data().name,
                    document_id: doc.id,
                    language_code: doc.data().language_code,
                    country_code: doc.data().country_code,
                    language_name: doc.data().language_name,
                    country: doc.data().country,
                    shown: true,
                }));

                dispatch(setOutputLanguages(filteredData));
            } else {
                dispatch(setOutputLanguages([]));
            }
        });
    } catch (error) {
        if (error instanceof Error) {
            errorLogger.critical(error?.message, 'getOutputLanguages');
        }
        console.log(error);
    }
};

export const getLanguages = (setOutputLanguages: Dispatch<SetStateAction<LanguagesType[]>>) => {
    try {
        const collectionRef = collection(db, LANGUAGES);
        const q = query(collectionRef);
        onSnapshot(q, (snapshot) => {
            if (snapshot.docs[0]) {
                const filteredData: LanguagesType[] = snapshot.docs.map((doc) => ({
                    key: doc.data().key,
                    title: doc.data().title,
                    document_id: doc.id,
                }));
                setOutputLanguages(filteredData);
            } else {
                setOutputLanguages([]);
            }
        });
    } catch (error) {
        if (error instanceof Error) {
            errorLogger.critical(error?.message, 'getLanguages');
        }
        console.log(error);
    }
};

export const getBrands = (setBrands: Dispatch<SetStateAction<BrandType[]>>) => {
    try {
        const collectionRef = collection(db, BRANDS);
        const q = query(collectionRef);
        onSnapshot(q, (snapshot) => {
            if (snapshot.docs[0]) {
                const filteredData: BrandType[] = snapshot.docs.map((doc) => ({
                    key: doc.data().key,
                    name: doc.data().name,
                    countries: doc.data().countries,
                    document_id: doc.id,
                }));
                setBrands(filteredData);
            } else {
                setBrands([]);
            }
        });
    } catch (error) {
        if (error instanceof Error) {
            errorLogger.critical(error?.message, 'getBrands');
        }
        console.log(error);
    }
};

export const getTargetCountries = (dispatch: AppDispatch) => {
    try {
        const collectionRef = collection(db, TARGET_COUNTRIES);
        const q = query(collectionRef);
        onSnapshot(q, (snapshot) => {
            if (snapshot.docs[0]) {
                const filteredData: TargetCountryType[] = snapshot.docs.map((doc) => ({
                    title: doc.data().title,
                    country_code: doc.data().country_code,
                    document_id: doc.id,
                }));

                dispatch(setTargetCountries(filteredData));
            } else {
                dispatch(setTargetCountries([]));
            }
        });
    } catch (error) {
        if (error instanceof Error) {
            errorLogger.critical(error?.message, 'getTargetCountries');
        }
        console.log(error);
    }
};

export const getDefaultLanguagesForJob = (
    doc_id: string,
    setLanguages: Dispatch<SetStateAction<JobLanguagesType | null>>,
) => {
    try {
        const unsubscribe = onSnapshot(doc(db, POST_DEFAULT_LANGUAGES, doc_id), (doc) => {
            const data = doc.data() as JobLanguagesType;
            setLanguages(data);
        });
        return unsubscribe;
    } catch (error) {
        if (error instanceof Error) {
            errorLogger.critical(error?.message, 'getContextQuery');
        }
        console.log(error);
        return null;
    }
};
